import styled from "styled-components";

export const MainContainter = styled.div`
  display: ${ p => p.close ? 'none' : 'flex'};
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 6px;
  background: #DC3232;
  min-height: 56px;
  height: fit-content;
  margin-bottom: 32px;
  width: 100%;
  position: relative;
`;

export const InfoIconContainer = styled.div`
  position: absolute;
  top: 16px;
  left: 24px;
`;

export const CloseTabIconContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 24px;
`;

export const TabText = styled.div`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  color: #FFFFFF;
  max-width: 85%;
  padding-left: 64px;
`;



